import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React, { useState, memo, useCallback, useEffect } from 'react';
import clsx from 'clsx';
import _get from 'lodash/get';
import { Checkbox } from 'reaxl';
import FilterCheckboxLabel from '../FilterCheckboxLabel';

/**
 *  Display Market Extension Filter
 *
 */
function FilterMarketExtension(_ref) {
  let {
    className,
    filters = {},
    onOptionChange = () => {},
    values = {},
    ...rest
  } = _ref;
  const [displayCheckbox, setDisplayCheckbox] = useState(_get(values, 'marketExtension') !== 'off');

  // Handle values filter changed from duck
  const {
    marketExtension: marketExtensionValue
  } = values;
  useEffect(() => {
    const applyMarketExtension = marketExtensionValue !== 'off';
    setDisplayCheckbox(applyMarketExtension);
  }, [marketExtensionValue]);
  const onChangeHandler = useCallback(event => {
    const newDisplayCheckbox = !displayCheckbox;
    setDisplayCheckbox(newDisplayCheckbox);
    /* set the e.target.value so that Redux picks up the correct selection from the Checkbox */
    event.target.value = newDisplayCheckbox ? 'include' : 'off';
    onOptionChange(event, filters);
  }, [displayCheckbox, filters, onOptionChange]);
  const displayMarketExtension = () => /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/_jsx(Checkbox, {
    checked: displayCheckbox,
    label: /*#__PURE__*/_jsx(FilterCheckboxLabel, {
      label: filters.title,
      moreInfo: filters.moreInfo,
      "aria-label": filters.title
    }),
    labelClassName: "margin-vertical-0",
    name: "marketExtension",
    onChange: onChangeHandler
  }));
  const rootClassName = clsx(className);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: rootClassName
  }, rest), filters && filters.visible && displayMarketExtension());
}
export default /*#__PURE__*/memo(FilterMarketExtension);